export default {
    webhookmanagement: {
        getdata: []
    },
};